import { render, staticRenderFns } from "./NonIndividualRegistry.vue?vue&type=template&id=847d2920&scoped=true&"
import script from "./NonIndividualRegistry.vue?vue&type=script&lang=js&"
export * from "./NonIndividualRegistry.vue?vue&type=script&lang=js&"
import style0 from "./NonIndividualRegistry.vue?vue&type=style&index=0&id=847d2920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847d2920",
  null
  
)

export default component.exports